import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import useAppDispatch from '../../../../hooks/useAppDispatch'
import BalanceErrorBanner from './components/BalanceErrorBanner'
import BalanceDisplay from './components/BalanceDisplay'
import BalanceEditForm from './components/BalanceEditForm'
import { editBalance, fetchBalanceDashboard } from '../../../../redux/features/dashboard/dashboardSlice'
import { getCurrencySymbol } from '../../../../utils/currency'

const BalanceComponent = () => {
	const { t } = useTranslation()
	const dispatch = useAppDispatch()
	const balance = useSelector((state) => state.dashboard.balance)
	const editingBalance = useSelector((state) => state.dashboard.editingBalance)
	const user = useSelector((state) => state.user.user)
	const defaultCurrency = useSelector((state) => state.user.defaultCurrency)

	const [localBalance, setLocalBalance] = useState(balance?.amount || 0)
	const [editing, setEditing] = useState(false)
	const [editingError, setEditingError] = useState(false)

	// Sync local balance with props balance (replaces componentDidUpdate)
	useEffect(() => {
		if (balance?.amount !== undefined) {
			setLocalBalance(balance.amount)
		}
	}, [balance?.amount])

	const handleEditClick = () => {
		setEditing(true)
		setEditingError(false)
	}

	const handleCancel = () => {
		setEditing(false)
		setLocalBalance(balance?.amount || 0)
		setEditingError(false)
	}

	const handleBalanceChange = (value) => {
		setLocalBalance(value)
	}

	const handleSave = async () => {
		try {
			await dispatch(editBalance({ amount: localBalance }))
			dispatch(fetchBalanceDashboard())
			setEditing(false)
			setEditingError(false)
		} catch (error) {
			setEditingError("Error")
		}
	}

	if (!user) {
		return null
	}

	const balanceAmount = balance?.amount || 0
	const isManager = user.is_manager
	const currencyCode = defaultCurrency?.currency_code || 'eur'
	const currencySymbol = getCurrencySymbol(currencyCode)

	return (
		<div className='block-white'>
			<div>
				<div style={{ width: `${isManager ? 'auto' : 'max-content'}` }}>
					<BalanceErrorBanner error={editingError} />
					{editing ? (
						<BalanceEditForm
							balance={localBalance}
							editingBalance={editingBalance}
							onSave={handleSave}
							onCancel={handleCancel}
							onBalanceChange={handleBalanceChange}
						/>
					) : (
						<BalanceDisplay
							balanceAmount={balanceAmount}
							currencySymbol={currencySymbol}
							t={t}
							isManager={isManager}
							onEditClick={handleEditClick}
						/>
					)}
				</div>
			</div>
		</div>
	)
}

export default BalanceComponent

